import { useT } from "../i18n";

const STYLES = {
  disponible: { bg: "#D1FAE5", text: "#065F46", border: "#34D399" },
  liste_attente: { bg: "#FEF3C7", text: "#92400E", border: "#FBBF24" },
  complet: { bg: "#FEE2E2", text: "#991B1B", border: "#F87171" },
  a_confirmer: { bg: "#F3F4F6", text: "#374151", border: "#9CA3AF" },
};

export default function StatusBadge({ status, testid }) {
  const { t } = useT();
  const s = STYLES[status] || STYLES.a_confirmer;
  return (
    <span
      data-testid={testid || `status-badge-${status}`}
      className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold"
      style={{ backgroundColor: s.bg, color: s.text, border: `1px solid ${s.border}` }}
    >
      <span className="w-2 h-2 rounded-full" style={{ backgroundColor: s.border }} aria-hidden="true" />
      {t(`status.${status}`)}
    </span>
  );
}
